"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _image = require("@site/pattern-library-core/image");
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _actions = _interopRequireDefault(require("../../../../../elements/other/actions"));
/* eslint-disable complexity */

/**
 * Local Imports
 */

const HeadContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadContainer",
  class: "pl-h64ci9b"
});
const FeaturedStyles = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FeaturedStyles",
  class: "pl-ffa4lxi",
  vars: {
    "ffa4lxi-0": [({
      isFeatured
    }) => isFeatured ? _intents.default.ux.box.backgroundColor : _intents.default.ux.boxHighContrast.foregroundColor]
  }
});
const ColumnWrapper = /*#__PURE__*/(0, _react2.styled)(FeaturedStyles)({
  name: "ColumnWrapper",
  class: "pl-ctmdyf4",
  vars: {
    "ctmdyf4-0": [({
      hasImage
    }) => hasImage ? 'repeat(2, 1fr)' : '1fr']
  }
});
const MobileImageContainer = /*#__PURE__*/(0, _react2.styled)(FeaturedStyles)({
  name: "MobileImageContainer",
  class: "pl-m3x7p6f"
});
const MobilePlanContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MobilePlanContainer",
  class: "pl-mt5r6ke",
  vars: {
    "mt5r6ke-0": [({
      hasImage
    }) => hasImage ? 'var(--viewport-space--300)' : `var(--viewport-space--200)`],
    "mt5r6ke-2": [({
      hasImage
    }) => hasImage ? '27rem' : `30vh`]
  }
});
const CtaWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CtaWrapper",
  class: "pl-cdxjf8o"
});
const ContentWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentWrapper",
  class: "pl-clpsmsq"
});

/**
 * HeadRowMobile Component.
 *
 * @param {Object} props React props
 * @param {Array} props.items Array of column items
 * @param {Number} props.toggleState Nav toggle state
 * @param {String} props.selected Selected Toggle State
 * @returns {React.ReactElement} HeadRowMobile Component
 * @public
 */

function HeadRowMobile({
  items,
  toggleState,
  selected
}) {
  const filteredItems = items?.filter(event => event);
  const filteredIndex = toggleState >= 0 && toggleState - 1 < filteredItems?.length ? toggleState - 1 : 0;
  return /*#__PURE__*/_react.default.createElement(HeadContainer, {
    "data-cy": "mobile",
    role: "row"
  }, filteredItems?.slice(filteredIndex, filteredIndex + 1)?.map((item, idx) => {
    const {
      image,
      planType,
      packageName,
      price,
      ctas,
      description,
      disclaimer
    } = item;
    return /*#__PURE__*/_react.default.createElement(ColumnWrapper, {
      key: idx,
      hasImage: image?.url,
      role: "cell",
      isFeatured: !image?.url && toggleState === Number(selected)
    }, image?.url && /*#__PURE__*/_react.default.createElement(MobileImageContainer, {
      isFeatured: toggleState === Number(selected),
      "data-cy": "mobile-image"
    }, /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
      url: image?.url,
      altText: image?.altText,
      height: image?.height,
      width: image?.width
    })), /*#__PURE__*/_react.default.createElement(MobilePlanContainer, {
      hasImage: !!image?.url
    }, planType && /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "title",
      "data-cy": "plan-type",
      text: planType
    }), packageName && /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "paragraph",
      size: -2,
      "data-cy": "package-name",
      text: packageName
    }), price && /*#__PURE__*/_react.default.createElement(_price.default, (0, _extends2.default)({}, price, {
      headlineSize: "h1"
    })), ctas && /*#__PURE__*/_react.default.createElement(CtaWrapper, null, ctas.length > 0 && /*#__PURE__*/_react.default.createElement(_actions.default, {
      actionsLayout: "button-set",
      ctas: ctas
    })), disclaimer && /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "paragraph",
      size: -2,
      "data-cy": "mobile-disclaimer",
      text: disclaimer
    })), description && /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "title",
      "data-cy": "mobile-description",
      text: description
    }))));
  }));
}
var _default = exports.default = HeadRowMobile;
HeadRowMobile.propTypes = {
  items: _propTypes.default.array,
  toggleState: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  selected: _propTypes.default.oneOf([1, 2, 3, 4, '1', '2', '3', '4'])
};